export const WhatsApp = () => (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4948 1.48211C20.3479 0.742716 25.4617 3.9453 27.9556 8.52C30.7635 13.6698 29.8507 19.7708 26.3137 23.88C24.1771 26.3619 20.5865 28.4043 17.3288 28.557C12.8572 28.7675 10.236 27.8681 7.0201 25.317C4.7923 23.5499 2.83646 20.3762 2.307 16.3794C1.55475 10.6978 4.97457 5.46444 9.27972 3.10502C11.0996 2.10763 12.1947 1.77325 14.4948 1.48211ZM13.7411 0.182048C12.6026 0.440041 11.8446 0.530844 10.7828 0.930085C8.83272 1.66083 6.43855 3.08484 5.12357 4.59821C4.80821 4.96142 4.52033 5.21077 4.19773 5.64316C1.82238 8.82556 0.582625 11.959 1.07737 17.0626C1.85131 25.0431 10.2649 31.1557 17.9161 29.8167C21.7366 29.148 25.3098 27.4934 27.5593 24.4681C30.0634 21.0983 31.4507 17.5138 30.8171 12.8727C30.0301 7.1032 25.6758 2.29068 20.5186 0.72542C18.7566 0.190695 15.7071 -0.263316 13.7397 0.182048H13.7411Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7245 21.2965C16.3184 21.2109 12.488 19.3101 9.86309 14.7507C8.93191 13.1294 9.06529 11.2815 10.4319 10.0126C10.8924 9.58212 11.4713 9.68785 12.0149 9.7785C12.1483 9.79863 12.2867 10.0026 12.3546 10.1536C12.7045 10.9492 13.0493 11.7447 13.3538 12.5604C13.5149 12.9909 13.2179 13.3963 12.5963 14.1138C12.3974 14.3404 12.3572 14.5493 12.5107 14.8137C13.5199 16.5232 14.9318 17.7593 16.7866 18.4843C17.0584 18.5901 17.2623 18.5246 17.436 18.3106C18.4199 17.1097 18.5206 16.7597 19.0366 17.0065C21.5256 18.1973 21.7193 18.2451 21.7319 18.5271C21.8176 20.6243 19.8922 21.3821 18.727 21.2965H18.7245Z"
      fill="currentColor"
    />
  </svg>
)
